import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  channelList: [],
  channelFormList: [],
  channelDetail: [],
  loading: false,
  error: undefined,
  success: false,
  actionType: null,
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    actionError(state) {
      state.loading = false;
      state.error = true;
    },
    fetchChannelList(state, action) {
      state.channelList = action.payload;
      state.loading = false;
    },
    fetchChannelFormList(state, action) {
      state.channelFormList = action.payload;
      state.loading = false;
    },
    fetchChannelDetail(state, action) {
      state.channelDetail = action.payload;
      state.loading = false;
    },
  },
});

export const channelActions = channelSlice.actions;

export default channelSlice.reducer;
